import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { LETTER_STEPS } from '../constants/referral.constants';
import LetterFormStep from './LetterFormStep';

export default function ReferralLetterEditor({ sections, onChange }) {
  const [step, setStep] = useState(0);
  const current = LETTER_STEPS[step];

  return (
    <div className="space-y-5">
      <div>
        <h3 className="font-heading text-xl text-[#071B34]">Compose referral letter</h3>
        <p className="text-sm text-stone-500">
          Step through each section — preview and PDF use campus letterhead for printing.
        </p>
      </div>

      <ol className="flex flex-wrap gap-2">
        {LETTER_STEPS.map((s, i) => (
          <li key={s.id}>
            <button
              type="button"
              onClick={() => setStep(i)}
              className={`rounded-full border px-3 py-1 text-xs font-medium transition ${
                i === step
                  ? 'border-[#071B34] bg-[#071B34] text-white'
                  : 'border-stone-200 bg-stone-50 text-stone-600 hover:border-stone-300'
              }`}
            >
              {i + 1}. {s.title}
            </button>
          </li>
        ))}
      </ol>

      <div className="rounded-lg border border-stone-100 bg-stone-50/80 px-4 py-3">
        <p className="text-sm font-medium text-[#071B34]">{current.title}</p>
        <p className="text-xs text-stone-500">{current.hint}</p>
      </div>

      <LetterFormStep fields={current.fields} sections={sections} onChange={onChange} />

      <div className="flex justify-between border-t border-stone-100 pt-4">
        <Button
          type="button"
          variant="outline"
          disabled={step === 0}
          onClick={() => setStep((s) => Math.max(0, s - 1))}
        >
          <ChevronLeft className="mr-1 h-4 w-4" /> Back
        </Button>
        <Button
          type="button"
          variant="outline"
          disabled={step >= LETTER_STEPS.length - 1}
          onClick={() => setStep((s) => Math.min(LETTER_STEPS.length - 1, s + 1))}
        >
          Next <ChevronRight className="ml-1 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
